import {ChangeDetectionStrategy, Component, DoCheck, EventEmitter, Input, Output, ViewChild,} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AgentModel} from "../../models/agent.model";
import {WidgetTypeEnum} from "../../../../dashboards/enums/widget-type.enum";

require('./agents-list.scss');
@Component({
  standalone: false,
  selector: 'app-agents-list',
  templateUrl: './agents-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsListComponent implements DoCheck {

  @Input() agents: AgentModel[];
  @Input() selectedAgentId: string;
  @Input() isItineraryMode: boolean;
  @Input() enableItineraryButton: boolean;
  @Input() enableDriverButton: boolean;
  @Input() enableChangeDriverStatus: boolean;
  @Input() isMinimizedData: boolean;

  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onAgentSelect = new EventEmitter<AgentModel>();
  @Output() onItineraryClick = new EventEmitter<AgentModel>();
  @Output() onChangeStatus = new EventEmitter<AgentModel>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  constructor() {
  }


  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }


  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  protected readonly WidgetTypeEnum = WidgetTypeEnum;
}
